var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { attrs: { align: "center", justify: "start" } },
        [
          _c(
            "v-col",
            {
              staticClass: "text-center",
              attrs: { cols: "5", sm: "5", md: "2" }
            },
            [
              _c("label", { staticClass: "font-weight-light" }, [
                _vm._v("La cinta será")
              ])
            ]
          ),
          _c(
            "v-col",
            { attrs: { cols: "3", sm: "6", md: "10" } },
            [
              _c(
                "v-radio-group",
                {
                  attrs: {
                    rules: [_vm.rules.required()],
                    row: _vm.$vuetify.breakpoint.smAndUp ? true : false
                  },
                  model: {
                    value: _vm.tape.giveOrTake,
                    callback: function($$v) {
                      _vm.$set(_vm.tape, "giveOrTake", $$v)
                    },
                    expression: "tape.giveOrTake"
                  }
                },
                [
                  _c("v-radio", {
                    attrs: {
                      label: "Entregada por Daycohost",
                      value: "Entrega",
                      color: "#60BB46"
                    }
                  }),
                  _c("v-radio", {
                    attrs: {
                      label: "Recibida por Daycohost",
                      value: "Recibe",
                      color: "#60BB46"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mr-2" },
        [
          _c(
            "v-col",
            [
              _c("v-text-field", {
                attrs: {
                  maxlength: "30",
                  label: "Código de la cinta",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(30),
                    _vm.rules.specialCharacters()
                  ]
                },
                model: {
                  value: _vm.tape.code,
                  callback: function($$v) {
                    _vm.$set(_vm.tape, "code", $$v)
                  },
                  expression: "tape.code"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }